// extracted by mini-css-extract-plugin
export default {"root":"DetailsLayout_root__bgHMe","main":"DetailsLayout_main__oTqgm"};